import { Link } from "react-router-dom";
import HomeLayout from "../../Buyer/commonComponents/HomeLayout";

const SellerTerms = () => {
  return (
    <HomeLayout>
      <section className="px-8 body-description sm:px-10 lg:px-[174px] pt-[30px] max-w-[1300px] mx-auto">
        <h2 className="h2 text-center">Terms and Conditions for Sellers</h2>
        <p className="body-description mt-8 text-justify">
          <strong>This Terms and Conditions Agreement</strong> is made between{" "}
          <strong>Sydani Group of Companies Limited</strong> of Plot 1422,
          Independence Avenue, Central Business District, Abuja (hereinafter
          referred to as <strong>“Sydani”</strong> which expression shall where
          the context so admits include its agents, representatives, privies,
          successor-in-title, and assigns) of the ONE PART AND
          <strong> Real Estate Developers</strong> (hereinafter referred to as
          the <strong>“Developer”</strong>, which expression shall where the
          context so admits, include its agents, representatives, privies,
          successor-in-title, and assigns) of the OTHER PART
        </p>
        <p className="font-bold mt-4">WHEREAS</p>
        <ul className="list-disc pl-14">
          <li>
            These Terms and Conditions govern All Real Estate Developers'
            participation as a Developer on the www.homeandabroad.ng operated by
            the Nigerians in Diaspora Commission (NiDCOM) and Sydani Group. By
            uploading your properties to this website and appending your
            signature to this document, you agree to comply with these terms.
          </li>
        </ul>
        <ul className="space-y-6 mt-4">
          <li>
            <p className="font-bold">1. Definitions</p>
            <span>In this Agreement, the term;</span>
            <ul className="list-disc pl-10 space-y-3 mt-2">
              <li>
                “Developer” refers to any entity that uploads property listings
                on the website.
              </li>
              <li>
                “Website” refers to the online property marketplace owned and
                operated by Sydani Group.
              </li>
              <li>
                “Property” refers to any real estate listing uploaded by the
                Developer on the website.
              </li>
              <li>
                {" "}
                “User” refers to individuals or entities who browse or purchase
                properties on the website.
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">2. Effective Date</p>
            <span>
              These Terms and Conditions shall be effective upon agreeing and
              clicking on the checkbox. The Developer shall first agree to these
              Terms and Conditions by clicking on the checkbox and or signing it
              and sending it back to Sydani, before uploading its properties on
              the Website.
            </span>
          </li>
          <li>
            <p className="font-bold">3. Acceptance of Terms</p>
            <span>
              By using the website, the Developer hereby acknowledges that he
              has read, understood, and agreed to be bound by the terms and
              conditions contained in this agreement. A violation of the terms
              outlined herein shall constitute grounds for immediate termination
              by Sydani and result in the immediate revocation of status as a
              Developer on the website.
            </span>
          </li>
          <li>
            <p className="font-bold">4. Pre-qualification for the Developer:</p>
            <ul className="space-y-6 pl-6 mt-4">
              <li>
                <span>
                  (a). The Developer shall be in good standing with the policies
                  laws and regulations of the Federal Republic of Nigeria; this
                  includes but is not limited to
                </span>
                <ul className="list-disc space-y-3 pl-14 mt-2">
                  <li>
                    Incorporation under Nigerian laws, compliance with tax laws,
                    building, regulations etc.
                  </li>
                  <li>
                    The Developer shall be a member of a recognized body such
                    as; the Real Estate Developers Association Nigeria (REDAN).
                  </li>
                  <li>
                    The Developer must be financially up to date with the
                    recognized body where it holds membership.
                  </li>
                </ul>
              </li>
              <li>
                <span>
                  (b). Before onboarding on the platform, the Developer must
                  show and later upload the following documents:
                </span>
                <ul className="list-disc space-y-3 pl-14 mt-3">
                  <li>Certificate of Incorporation (Verified by Tech Team)</li>
                  <li>Real Estate License</li>
                  <li>Recent Tax clearance certificate</li>
                  <li>
                    Proof of Address (Utility Bill) (Verified by Tech Team)
                  </li>
                  <li>Valid Directors ID (Verified by Tech Team)</li>
                  <li>Tax Identification Number</li>
                </ul>
              </li>
              <li>
                <span>
                  (c). For a Developer’s property to be approved and listed on
                  the platform, the following documents must be uploaded for
                  verification:
                </span>
                <ul className="list-disc space-y-3 pl-14 mt-3">
                  <li>
                    {" "}
                    Property Valuation Report (Gotten from Reputable Valuation
                    companies)
                  </li>
                  <li>Title Document</li>
                  <li>Building Approval</li>
                  <li>Legal Search</li>
                  <li>
                    Structural Integrity Certification. (Gotten from Reputable
                    Valuation or construction companies)
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">5. Responsibilities of the Developer:</p>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li>
                The Developer must ensure that all information provided on the
                website regarding their properties is accurate, current, and not
                misleading, and in compliance with applicable laws and
                regulations, including but not limited to real estate
                regulations applicable in Nigeria.
              </li>
              <li>
                The Developer represents and warrants that they own or have the
                necessary rights to the properties you have listed on the
                website.
              </li>
              <li>
                The Developer is responsible for removing any listings for
                properties that are sold, leased, or no longer available.
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">6. Prohibited Conduct</p>
            <span className="mt-2">The Developer is prohibited from:</span>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li>
                Uploading information about any property which is false or
                misleading to the users.
              </li>
              <li>
                Use the website for any illegal, unlawful, or unauthorised
                purpose.
              </li>
              <li>
                Transmit any materials that may be harmful to the Website or
                disrupt the use of the Website.
              </li>
              <li>
                Engage in any conduct that may damage the reputation of Sydani
                Group and NiDCOM.
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">7. Sanctions</p>
            <span className="mt-2">
              Where the Developer breaches any provision contained herein, it
              shall be liable to any of the following sanctions:
            </span>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  Blacklisted once found defaulting with the terms and
                  conditions listed herein.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  Damages for any loss that Sydani Group incurs as a result of
                  the breach.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  Refund to the buyer where the title transferred to the buyer
                  by the developer is found to be defective or where the
                  description of a listed property by the Developer is found to
                  be substantially inaccurate. Such a refund shall be the full
                  amount paid by the Buyer into the escrow account. Sydani Group
                  is entitled to retain the commission paid or payable to it and
                  shall not be invited to contribute such a refund.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>d.</span>
                <span>
                  Fines as may be determined by Sydani Group, and based on the
                  extent of the violation.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>e.</span>
                <span>
                  Reported to the appropriate law enforcement bodies, which
                  include but are not limited to the Nigerian Police Force,
                  Economic and Financial Crimes Commission, etc., if found to be
                  engaging in criminal acts/practices.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>f.</span>
                <span>
                  Prior to any sanctions, including blacklisting or reporting to
                  authorities, the Developer shall be given ab written notice of
                  the alleged breach and allowed 14 days (”Review Period”) to
                  respond to and cure the violation. PROVIDED that Sydani Group
                  reserves the right to suspend the Developer during the Review
                  Period and may, where not satisfied with the Developer’s
                  response or cure, proceed with the above stated sanctions upon
                  the expiration of the review period.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>g.</span>
                <span>
                  Any disputes arising from this clause shall be resolved in
                  accordance with the dispute resolution clause of this
                  Agreement.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">8. Intellectual Property:</p>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  All content provided by Sydani Group, including but not
                  limited to text, graphics, logos, and software (collectively
                  referred to as “contents”), is owned by Sydani Group. The
                  Developer is granted a limited license to use these contents
                  solely to list properties on the platform for sale.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  All text, graphics, logos, and software owned by, and uploaded
                  to the Home and Abroad Platform by the Developer, shall remain
                  the exclusive property of the Developer. The Developer hereby
                  grants Sydani Group a worldwide, irrevocable, non-exclusive,
                  royalty-free license to use these contents solely for the
                  purposes of listing properties on the Platform, facilitating
                  property sale on the Platform, and any other incidental
                  purposes. In the event that Sydani Group wishes to use any of
                  these assets for any purpose other than the purposes stated
                  herein or other incidental purposes, prior written consent
                  must be obtained from the Developer.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  The Developer hereby warrants that it has the rights to all
                  contents it shall upload unto the Platform, and where the
                  Developer is found to not have such rights, it agrees to fully
                  indemnify Sydani Group of any claim arising from such breach
                  of Intellectual Property rights in accordance with the
                  indemnification clause in this Agreement.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>d.</span>
                <span>
                  Unless the Developer owns or controls the relevant rights in
                  the content, the Developer must not:
                  <br />
                  <ul>
                    <li className="flex space-x-3">
                      <span>i.</span>
                      <span>
                        Republish contents from our website (including
                        republication on another website);
                      </span>
                    </li>
                    <li className="flex space-x-3">
                      <span>ii.</span>
                      <span>
                        Sell, rent, or sub-license contents from our website;
                      </span>
                    </li>
                    <li className="flex space-x-3">
                      <span>iii.</span>
                      <span>
                        Exploit material from our website for a commercial
                        purpose; or
                      </span>
                    </li>
                    <li className="flex space-x-3">
                      <span>iv.</span>
                      <span>
                        Redistribute material from our website. <br />{" "}
                        Notwithstanding the provisions of the immediately
                        preceding clause, the Developer may forward links to
                        properties on our Platform and redistribute our
                        newsletter and promotional materials in print and
                        electronic form to any person.
                      </span>
                    </li>
                  </ul>
                </span>
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">9. Limitation of Liability:</p>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  Sydani Group and NiDCOM shall not be liable for any direct,
                  indirect, incidental, special, consequential, or punitive
                  damages arising from your use of the Website, or from any
                  property listed therein.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  The Developer shall not be held liable for any inaccuracies,
                  misrepresentations, or omissions in property listings caused
                  by system malfunctions, cybersecurity breaches, or
                  unauthorised third-party actions. Actions by a staff,
                  employee, or agent of the Developer shall not be considered
                  third-party actions.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  The Developer absolves Sydani Group and NiDCOM from any
                  liability arising out of, but not limited to, the sale of
                  property and any ownership dispute arising from any sale of
                  property transactions.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">10. Data Protection:</p>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  Both Parties must protect Personal Data, process it only as
                  agreed, and follow Nigerian data protection laws (Nigerian
                  Data Protection Act and the General Application and
                  Implementation Directive (GAID) 2025). Each Party shall use
                  secure methods to keep Personal Data safe from unauthorised
                  access, loss, or theft.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  Where a Party processes Personal Data for the other (as a Data
                  Processor), it must follow the other's instructions, get
                  approval before using sub-processors, and help with data
                  subject requests or audits. Where a data breach has occurred,
                  the responsible Party must notify the other Party immediately
                  and shall take quick steps to fix the issue. Personal Data
                  must not be transferred outside Nigeria without both parties’
                  written consent.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  The Developer agrees to abide by our Privacy Policy (link to
                  it) and Cookie Notice in its use of Buyers’ personal data
                  obtained from our Platform.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>d.</span>
                <span>
                  The Developer certifies that it has adequate internal data
                  protection policies that protect personal data and prevents
                  its loss, misuse, or mishandling in any way and for purposes
                  other than the facilitation of an ongoing transaction between
                  it and a Buyer.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>e.</span>
                <span>
                  The Buyer agrees not to use data collected from our Platform
                  for any direct marketing activity, including email marketing,
                  SMS marketing, telemarketing, and direct mailing.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>f.</span>
                <span>
                  The Developer agrees to fully indemnify Sydani Group of any
                  claim arising from its breach of any Buyer’s data privacy
                  rights in accordance with the indemnification clause in this
                  Agreement.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>g.</span>
                <span>
                  Upon termination of this Agreement, Personal Data must be
                  returned or securely deleted, unless where it is required by
                  law to be kept. Both Parties shall cooperate to protect data
                  subject rights, like access or deletion requests, and
                  indemnify each other for any fines or damages caused by
                  breaching this clause or the Nigerian data protection laws in
                  accordance with the indemnification clause herein.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">11. Indemnification:</p>
            <span>
              Each party (the “Indemnifying Party”) agrees to indemnify, defend,
              and hold harmless the other party (the “Indemnified Party”) from
              and against any and all claims, losses, liabilities, damages,
              costs, or expenses (including reasonable legal fees) arising out
              of or relating to:
            </span>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  Any breach of these Terms and Conditions by the Indemnifying
                  Party;
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  The use or misuse of the Website by the Indemnifying Party;
                  and
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  Any negligent or wrongful act or omission by the Indemnifying
                  Party in connection with the development, operation, or use of
                  the Website.
                </span>
              </li>
            </ul>
            <p className="mt-1">
              This mutual indemnity shall survive the termination or expiration
              of these Terms and Conditions.
            </p>
          </li>
          <li>
            <p className="font-bold">12. Waiver:</p>
            <span>
              The waiver by Sydani Group of a breach(es) of any provision of
              this Agreement will not operate or be construed as a continuing
              waiver.
            </span>
          </li>
          <li>
            <p className="font-bold">13. Assignment:</p>
            <span>
              The Developer shall not assign any of its rights under this
              Agreement or delegate the performance of any of its duties under
              the terms of this Agreement without the prior consent of Sydani
              Group and NiDCOM being sought and obtained in writing.
            </span>
          </li>
          <li>
            <p className="font-bold">14. Fees Payment:</p>
            <span>The Developer agrees to pay Sydani Group; </span>
            <ul className="pl-6 space-y-4 mt-2">
                <li>
                    <span className="font-bold">a. Periodic Subscription</span>
                    <ul className="pl-6 space-y-2">
                        <li className="flex space-x-3">
                            <span>i.</span>
                            <span>Monthly - N100,000.00 or</span>
                        </li>
                        <li className="flex space-x-3">
                            <span>ii.</span>
                            <span>Bi-annual - N550,000.00 or</span>
                        </li>
                        <li className="flex space-x-3">
                            <span>iii.</span>
                            <span>Annual - N1,000,000.00 or</span>
                        </li>
                    </ul>
                </li>
                <li>
                    <span className="font-bold">b. Fees on Sale</span>
                    <li className="flex space-x-3">
                        <span>i.</span>
                        <span>5% of the gross value of every property sold</span>
                    </li>
                </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">15. Moratorium Period:</p>
            <span>
              The Developer shall not be required to make any payment of
              subscription in the first 2 months of onboarding unto the
              platform.
            </span>
          </li>
          <li>
            <p className="font-bold">16. Terms of Payment:</p>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  Payments by buyers (“Purchase Fee”) for the Developer’s
                  properties listed on the Home and Abroad Platform shall be
                  made to a designated Home and Abroad escrow account controlled
                  by the bank with which the said account is domiciled.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  Sydani Group shall only authorise the bank to remit the
                  Purchase Fee, less the applicable fees on sale, from the
                  escrow account to the Developer’s account after all
                  transaction documents, including allocation letter, sale
                  receipt, title document etc., have been transferred to the
                  buyer of such property.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  The Developer is expressly prohibited from receiving payments
                  on the sale of property directly from any buyer.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <p className="font-bold">
              17. Anti-Money Laundering and Anti-Terrorism Commitment:
            </p>
            <span>
              The Parties shall comply with the Money Laundering (Prevention and
              Prohibition) Act, 2022, and the Terrorism (Prevention and
              Prohibition) Act, 2022. Both Parties commit to ensure that all
              funds used in this Agreement are from legitimate sources, free
              from money laundering or terrorist financing. Neither Party shall
              engage in or facilitate illicit financial activities. Any breach
              of this clause or violation of the stated Acts entitles the non-
              breaching Party to terminate this Agreement immediately upon
              written notice, without prejudice to other remedies. The breaching
              Party shall indemnify the non-breaching Party for any losses,
              fines, or penalties arising from such breach. This clause survives
              termination of the Agreement.
            </span>
          </li>
          <li>
            <p className="font-bold">18. Alteration</p>
            <span>
              Sydani Group reserves the right to make regular alterations and
              amendments to this Agreement as it may deem necessary, PROVIDED
              that any such alteration shall not take effect until consented to
              in writing by the Developer within seven (7) days from the date of
              receiving notice of the alteration, such consent not to be
              unreasonably withheld. Where, at the end of the period stated in
              this clause, the Developer had failed or refused to consent to the
              alteration, Sydani shall have the right to terminate this
              Agreement or exercise the option of entering into a negotiation on
              the alteration with the Developer. This negotiation shall be
              guided by prior mutually agreed terms that will set out the
              parameters of the said negotiation.
            </span>
          </li>
          <li>
            <p className="font-bold">19. Governing Law</p>
            <span>
              This Agreement shall be governed by and construed in strict
              accordance with the laws of the Federal Republic of Nigeria.
            </span>
          </li>
          <li>
            <p className="font-bold">20. Dispute Resolution</p>
            <span>
              Where any dispute arises from this Agreement, either Party may
              refer such dispute to binding arbitration. The arbitration shall
              be conducted in accordance with the provisions of the Arbitration
              and Mediation Act 2023, in Nigeria, unless the Parties mutually
              agree upon another venue. A panel of three [3] arbitrators shall
              conduct the arbitration; one each appointed by each party and the
              third appointed by the other two. The arbitrators appointed shall
              be Nigerians. The Arbitrators’ award shall be binding on the
              Parties, and no right of appeal shall lie. The Parties agree to
              the Jurisdiction of the appropriate courts in Nigeria and/or the
              site of the arbitration for the purpose of interim measures and to
              the jurisdiction of any court of competent jurisdiction for
              enforcement of the award. The Parties shall share the cost of the
              arbitration evenly, except for their respective individual costs,
              which they shall bear individually.
            </span>
          </li>
          <li>
            <p className="font-bold">21. Termination</p>
            <span>
              The termination of this Agreement shall not operate as a bar on
              any existing or future liability that may arise due to a breach of
              any term contained in this Agreement.
            </span>{" "}
            <br />
            <span>
              This Agreement may be terminated in any of the following
              circumstances:
            </span>
            <ul className="pl-10 space-y-2 list-disc mt-3">
              <li className="flex space-x-3">
                <span>a.</span>
                <span>
                  Where the periodic subscription fee of the Developer to the
                  platform has expired, and the Developer fails to exercise its
                  option to renew its subscription.{" "}
                </span>
              </li>
              <li className="flex space-x-3">
                <span>b.</span>
                <span>
                  Where either party violates any terms contained in this
                  Agreement or engages in conduct detrimental to the integrity
                  of the platform.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>c.</span>
                <span>
                  Where either of the parties terminates the agreement in
                  writing, giving a minimum of one month's notice to the other
                  party stating reasonable ground(s) for such termination,
                  PROVIDED that the said termination would not absolve the
                  Developer from liabilities that has arisen or may arise due to
                  a sale or previous sale on the platform.
                </span>
              </li>
              <li className="flex space-x-3">
                <span>d.</span>
                <span>
                  Where any of the representations and warranties made by either
                  party to the other turn out to be false.
                </span>
              </li>
            </ul>
          </li>
        </ul>
        <p className="font-bold mt-8 text-2xl">By uploading your properties to the Website and appending your signature to this
Agreement, you agree to these terms and conditions.</p>
      </section>
    </HomeLayout>
  );
};

export default SellerTerms;
